import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import client from '../api/client';

export default function Register() {
  const navigate = useNavigate();
  const [step, setStep] = useState<'form' | 'verify'>('form');
  const [form, setForm] = useState({ email: '', password: '', name: '', phone: '' });
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [codeSent, setCodeSent] = useState(false);
  const [countdown, setCountdown] = useState(0);

  const inp = { width: '100%', background: '#0F1117', border: '0.5px solid #2A3045', borderRadius: 8, padding: '10px 12px', color: '#E8ECF4', fontSize: 14, boxSizing: 'border-box' as const };

  const startCountdown = () => {
    setCountdown(300);
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) { clearInterval(timer); return 0; }
        return prev - 1;
      });
    }, 1000);
  };

  const handleSendCode = async () => {
    if (!form.email) return setError('이메일을 입력해주세요');
    setSendLoading(true); setError('');
    try {
      await client.post('/auth/send-code', { email: form.email });
      setCodeSent(true);
      setStep('verify');
      startCountdown();
    } catch (e: any) {
      setError(e.response?.data?.detail || '코드 발송 실패');
    } finally { setSendLoading(false); }
  };

  const handleResend = async () => {
    setSendLoading(true); setError('');
    try {
      await client.post('/auth/send-code', { email: form.email });
      setCountdown(300);
      startCountdown();
      setError('');
    } catch (e: any) {
      setError(e.response?.data?.detail || '재발송 실패');
    } finally { setSendLoading(false); }
  };

  const handleRegister = async () => {
    if (code.length !== 6) return setError('6자리 코드를 입력해주세요');
    setLoading(true); setError('');
    try {
      const res = await client.post('/auth/register', { ...form, code });
      localStorage.setItem('token', res.data.access_token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      navigate('/dashboard');
    } catch (e: any) {
      setError(e.response?.data?.detail || '회원가입 실패');
    } finally { setLoading(false); }
  };

  const formatTime = (s: number) => `${Math.floor(s/60)}:${String(s%60).padStart(2,'0')}`;

  return (
    <div style={{ minHeight: '100vh', background: '#0F1117', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#161B27', border: '0.5px solid #2A3045', borderRadius: 12, padding: '40px 36px', width: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h1 style={{ color: '#00D4AA', fontSize: 24, fontWeight: 700, margin: 0 }}>SellerRanky</h1>
          <p style={{ color: '#8892A4', fontSize: 13, marginTop: 8 }}>무료로 시작하세요</p>
        </div>

        {step === 'form' && (
          <>
            {[
              { key: 'name', label: '이름', type: 'text' },
              { key: 'password', label: '비밀번호', type: 'password' },
              { key: 'phone', label: '전화번호 (선택)', type: 'tel' },
            ].map(field => (
              <div key={field.key} style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', color: '#8892A4', fontSize: 12, marginBottom: 6 }}>{field.label}</label>
                <input type={field.type} required={field.key !== 'phone'}
                  value={(form as any)[field.key]}
                  onChange={e => setForm({...form, [field.key]: e.target.value})}
                  style={inp} />
              </div>
            ))}

            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', color: '#8892A4', fontSize: 12, marginBottom: 6 }}>이메일</label>
              <div style={{ display: 'flex', gap: 8 }}>
                <input type="email" required value={form.email}
                  onChange={e => setForm({...form, email: e.target.value})}
                  onKeyDown={e => e.key === 'Enter' && handleSendCode()}
                  placeholder="이메일 입력"
                  style={{ ...inp, flex: 1 }} />
                <button onClick={handleSendCode} disabled={sendLoading || !form.email}
                  style={{ background: '#00D4AA', border: 'none', borderRadius: 8, padding: '10px 16px', color: '#0A1F18', fontSize: 13, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' as const, flexShrink: 0 }}>
                  {sendLoading ? '발송중...' : '인증코드 발송'}
                </button>
              </div>
            </div>

            {error && <p style={{ color: '#F56565', fontSize: 13, marginBottom: 12 }}>{error}</p>}
          </>
        )}

        {step === 'verify' && (
          <>
            <div style={{ background: '#0F2A22', border: '1px solid #00D4AA33', borderRadius: 8, padding: '12px 16px', marginBottom: 20 }}>
              <div style={{ color: '#00D4AA', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>📧 인증 코드 발송 완료</div>
              <div style={{ color: '#8892A4', fontSize: 12 }}><strong style={{ color: '#E8ECF4' }}>{form.email}</strong> 으로 6자리 코드를 보냈습니다</div>
            </div>

            <div style={{ marginBottom: 20 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                <label style={{ color: '#8892A4', fontSize: 12 }}>인증 코드 6자리</label>
                {countdown > 0 && <span style={{ color: '#F6AD55', fontSize: 12 }}>⏱ {formatTime(countdown)}</span>}
              </div>
              <input
                value={code} onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                placeholder="000000"
                maxLength={6}
                style={{ ...inp, fontSize: 24, fontWeight: 700, letterSpacing: 8, textAlign: 'center' as const }}
              />
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 8 }}>
                <button onClick={() => { setStep('form'); setCode(''); setError(''); }}
                  style={{ background: 'none', border: 'none', color: '#8892A4', fontSize: 12, cursor: 'pointer' }}>
                  ← 이메일 변경
                </button>
                {countdown === 0 && (
                  <button onClick={handleResend} disabled={sendLoading}
                    style={{ background: 'none', border: 'none', color: '#00D4AA', fontSize: 12, cursor: 'pointer' }}>
                    {sendLoading ? '발송중...' : '코드 재발송'}
                  </button>
                )}
              </div>
            </div>

            {error && <p style={{ color: '#F56565', fontSize: 13, marginBottom: 12 }}>{error}</p>}

            <button onClick={handleRegister} disabled={loading || code.length !== 6}
              style={{ width: '100%', background: code.length === 6 ? '#00D4AA' : '#1A2A22', border: 'none', borderRadius: 8, padding: '12px', color: code.length === 6 ? '#0A1F18' : '#4A5568', fontSize: 14, fontWeight: 700, cursor: code.length === 6 ? 'pointer' : 'default' }}>
              {loading ? '가입 중...' : '회원가입 완료'}
            </button>
          </>
        )}

        <p style={{ textAlign: 'center', marginTop: 20, color: '#8892A4', fontSize: 13 }}>
          이미 계정이 있으신가요? <Link to="/login" style={{ color: '#00D4AA' }}>로그인</Link>
        </p>
      </div>
    </div>
  );
}
